<template>
  <router-view/>
</template>

<script setup>

</script>

<style lang="scss">
html {
  font-size: 14px;
}
</style>
